export default __webpack_public_path__ + "static/media/karstenDecorDark.767c3b36.png";